module.exports = __webpack_public_path__ + "static/img/headbackground.d600859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthReportList/headbackground.png
// module id = +3Rp
// module chunks = 59